(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ak-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ak-plp-collection-description"] && !Shopify.designMode) return;
  try {
    
  class AkPlpCollectionDescription extends HTMLElement {
    /** @type {ResizeObserver | null} */
    #resizeObserver = null;

    /** @type {boolean} */
    #expanded = false;

    connectedCallback() {
      const content = this.querySelector('[data-ak-plp-desc-content]');
      const toggle = this.querySelector('[data-ak-plp-desc-toggle]');

      if (!(content instanceof HTMLElement) || !(toggle instanceof HTMLButtonElement)) {
        return;
      }

      this.#content = content;
      this.#toggle = toggle;

      toggle.addEventListener('click', this.#onToggle);

      this.#resizeObserver = new ResizeObserver(() => {
        if (!this.#expanded) {
          this.#measureOverflow();
        }
      });
      this.#resizeObserver.observe(content);

      requestAnimationFrame(() => {
        this.#measureOverflow();
      });
    }

    disconnectedCallback() {
      this.#toggle?.removeEventListener('click', this.#onToggle);
      this.#resizeObserver?.disconnect();
      this.#resizeObserver = null;
    }

    /** @type {HTMLElement | null} */
    #content = null;

    /** @type {HTMLButtonElement | null} */
    #toggle = null;

    #onToggle = () => {
      this.#expanded = !this.#expanded;
      this.#applyExpandedState();
    };

    #measureOverflow() {
      const content = this.#content;
      const toggle = this.#toggle;

      if (!content || !toggle || this.#expanded) {
        return;
      }

      content.classList.add('is-clamped');
      content.inert = false;

      const overflowing = content.scrollHeight > content.clientHeight + 1;

      toggle.hidden = !overflowing;

      if (!overflowing) {
        content.classList.remove('is-clamped');
        content.inert = false;
      } else {
        // Keep clipped links out of the tab order while collapsed (WCAG).
        content.inert = true;
      }
    }

    #applyExpandedState() {
      const content = this.#content;
      const toggle = this.#toggle;

      if (!content || !toggle) {
        return;
      }

      const labelMore = toggle.querySelector('[data-ak-plp-desc-label-more]');
      const labelLess = toggle.querySelector('[data-ak-plp-desc-label-less]');

      toggle.setAttribute('aria-expanded', this.#expanded ? 'true' : 'false');

      if (this.#expanded) {
        content.classList.remove('is-clamped');
        content.inert = false;
        if (labelMore instanceof HTMLElement) labelMore.hidden = true;
        if (labelLess instanceof HTMLElement) labelLess.hidden = false;
      } else {
        content.classList.add('is-clamped');
        if (labelMore instanceof HTMLElement) labelMore.hidden = false;
        if (labelLess instanceof HTMLElement) labelLess.hidden = true;
        this.#measureOverflow();
      }
    }
  }

  if (!customElements.get('ak-plp-collection-description')) {
    customElements.define('ak-plp-collection-description', AkPlpCollectionDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ak-plp-visual-subcategories"] && !Shopify.designMode) return;
  try {
    
  class AkPlpVisualSubcategories extends HTMLElement {
    connectedCallback() {
      const current = this.querySelector('.ak-plp-subcats__link--current');
      const item = current?.closest('.ak-plp-subcats__item');

      if (!(item instanceof HTMLElement)) {
        return;
      }

      requestAnimationFrame(() => {
        item.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'auto' });
      });
    }
  }

  if (!customElements.get('ak-plp-visual-subcategories')) {
    customElements.define('ak-plp-visual-subcategories', AkPlpVisualSubcategories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (function measureAnnouncementHeight() {
    const bar = document.querySelector('[data-ak-announcement-bar]');
    const section = bar?.closest('.shopify-section');
    if (!(section instanceof HTMLElement)) return;

    const write = () => {
      document.body.style.setProperty('--announcement-height', `${Math.round(section.offsetHeight)}px`);
    };
    write();
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(write).observe(section);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
